import React, { useState, useEffect } from "react";
import { useAuth } from "@/lib/AuthContext";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function ProductoDialog({ open, onClose, onSubmit, producto, categorias, isLoading }) {
  const [formData, setFormData] = useState({
    nombre: "",
    categoria_id: "",
    descripcion: "",
    url_proveedor: "",
    margen_propio: null,
    coste_fijo_propio: null,
    activo: true
  });
  const [isAdmin, setIsAdmin] = useState(false);

  /* eslint-disable-next-line no-unused-vars */
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      setIsAdmin(true);
    }
  }, [user]);

  useEffect(() => {
    if (producto) {
      setFormData(producto);
    } else {
      setFormData({
        nombre: "",
        categoria_id: "",
        descripcion: "",
        url_proveedor: "",
        margen_propio: null,
        coste_fijo_propio: null,
        activo: true
      });
    }
  }, [producto, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = {
      ...formData,
      margen_propio: formData.margen_propio === "" || formData.margen_propio === null ? null : parseFloat(formData.margen_propio),
      coste_fijo_propio: formData.coste_fijo_propio === "" || formData.coste_fijo_propio === null ? null : parseFloat(formData.coste_fijo_propio),
    };
    onSubmit(dataToSend);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-xl dark:bg-gray-900">
        <DialogHeader>
          <DialogTitle className="text-2xl text-gray-900 dark:text-white">
            {producto ? "Editar Producto" : "Nuevo Producto"}
          </DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            <div>
              <Label htmlFor="nombre" className="dark:text-gray-300">Nombre *</Label>
              <Input
                id="nombre"
                value={formData.nombre}
                onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                required
                className="dark:bg-gray-800 dark:border-gray-700"
              />
            </div>

            <div>
              <Label htmlFor="categoria" className="dark:text-gray-300">Categoría *</Label>
              <Select 
                value={formData.categoria_id} 
                onValueChange={(val) => setFormData({...formData, categoria_id: val})}
              >
                <SelectTrigger className="dark:bg-gray-800 dark:border-gray-700">
                  <SelectValue placeholder="Seleccionar categoría" />
                </SelectTrigger>
                <SelectContent>
                  {categorias.map(cat => (
                    <SelectItem key={cat.id} value={cat.id}>{cat.nombre}</SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </div>

            <div>
              <Label htmlFor="descripcion" className="dark:text-gray-300">Descripción</Label>
              <Textarea
                id="descripcion"
                value={formData.descripcion}
                onChange={(e) => setFormData({...formData, descripcion: e.target.value})}
                rows={3}
                className="dark:bg-gray-800 dark:border-gray-700"
              />
            </div>

            <div>
              <Label htmlFor="url_proveedor" className="dark:text-gray-300">URL Proveedor</Label>
              <Input
                id="url_proveedor"
                type="url"
                value={formData.url_proveedor || ""}
                onChange={(e) => setFormData({...formData, url_proveedor: e.target.value})}
                placeholder="https://www.proveedor.com/producto"
                className="dark:bg-gray-800 dark:border-gray-700"
              />
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                URL para acceder al producto en la web del proveedor
              </p>
            </div>

            {isAdmin && (
              <div className="border-t border-gray-200 dark:border-gray-700 pt-4">
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                  Valores propios (opcional - si no se especifican, se usan los de la categoría)
                </p>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <Label htmlFor="margen" className="dark:text-gray-300">Margen propio (%)</Label>
                    <Input
                      id="margen"
                      type="number"
                      step="0.1"
                      value={formData.margen_propio || ""}
                      onChange={(e) => setFormData({...formData, margen_propio: e.target.value})}
                      placeholder="Heredado de categoría"
                      className="dark:bg-gray-800 dark:border-gray-700"
                    />
                  </div>

                  <div>
                    <Label htmlFor="coste" className="dark:text-gray-300">Coste fijo propio (€)</Label>
                    <Input
                      id="coste"
                      type="number"
                      step="0.01"
                      value={formData.coste_fijo_propio || ""}
                      onChange={(e) => setFormData({...formData, coste_fijo_propio: e.target.value})}
                      placeholder="Heredado de categoría"
                      className="dark:bg-gray-800 dark:border-gray-700"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} disabled={isLoading}>
              Cancelar
            </Button>
            <Button type="submit" disabled={isLoading} className="bg-indigo-600 hover:bg-indigo-700">
              {isLoading ? "Guardando..." : producto ? "Actualizar" : "Crear"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}